import { RootState } from '@lib/store'
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { startOfWeek, endOfDay } from 'date-fns'

interface DateRange {
  from: string
  to: string
}

interface UsageState {
  dateRange: DateRange
  distributionsDateRange: DateRange
}

const buildInitialMonthRange = (): DateRange => {
  const now = new Date()
  const year = now.getUTCFullYear()
  const month = now.getUTCMonth()
  return {
    from: new Date(Date.UTC(year, month, 1)).toISOString(),
    to: new Date(Date.UTC(year, month + 1, 0, 23, 59, 59, 999)).toISOString(),
  }
}

const initialState: UsageState = {
  dateRange: buildInitialMonthRange(),
  distributionsDateRange: {
    from: startOfWeek(new Date()).toISOString(),
    to: endOfDay(new Date()).toISOString(),
  },
}

const usageSlice = createSlice({
  name: 'usage',
  initialState,
  reducers: {
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload
    },
    setDistributionsDateRange: (state, action: PayloadAction<DateRange>) => {
      state.distributionsDateRange = action.payload
    },
    setMonthRange: (
      state,
      action: PayloadAction<{ year: number; month: number }>
    ) => {
      const { year, month } = action.payload
      const from = new Date(Date.UTC(year, month, 1))
      const to = new Date(Date.UTC(year, month + 1, 0, 23, 59, 59, 999))
      state.dateRange.from = from.toISOString()
      state.dateRange.to = to.toISOString()
    },
  },
})

export const { setDateRange, setDistributionsDateRange, setMonthRange } =
  usageSlice.actions
export default usageSlice.reducer

export const selectDateRange = (state: RootState) => state.usage.dateRange

export const selectDistributionsDateRange = (state: RootState) =>
  state.usage.distributionsDateRange

export const selectDistributionsDateRangeDates = createSelector(
  [(state: RootState) => state.usage.distributionsDateRange],
  (
    distributionsDateRange
  ): {
    from: Date
    to: Date
  } => ({
    from: new Date(distributionsDateRange.from),
    to: new Date(distributionsDateRange.to),
  })
)
